export default __webpack_public_path__ + "static/media/figuremap63.b6564e97.png";